// Google Consent Mode v2 helpers
export const CONSENT_KEY = "geolitio_consent";

export const DEFAULT_CONSENT = {
  necessary: true,
  functional: true,
  analytics: false,
  ads: false,
};

function ensureGtag() {
  if (typeof window === "undefined") return null;
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
  return window.gtag;
}

export function readConsent() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_CONSENT, ...parsed };
  } catch (e) {
    return null;
  }
}

export function saveConsent(state) {
  if (typeof window === "undefined") return;
  const merged = { ...DEFAULT_CONSENT, ...state, savedAt: new Date().toISOString() };
  try {
    window.localStorage.setItem(CONSENT_KEY, JSON.stringify(merged));
  } catch (e) {
    // ignore
  }
  applyConsent(merged);
}

export function applyConsent(state) {
  const gtag = ensureGtag();
  if (!gtag) return;
  gtag("consent", "update", {
    ad_storage: state.ads ? "granted" : "denied",
    ad_user_data: state.ads ? "granted" : "denied",
    ad_personalization: state.ads ? "granted" : "denied",
    analytics_storage: state.analytics ? "granted" : "denied",
    functionality_storage: state.functional ? "granted" : "denied",
    personalization_storage: state.functional ? "granted" : "denied",
    security_storage: "granted",
  });
  window.dataLayer.push({ event: "cookie_consent_update" });
}

export function acceptAll() {
  saveConsent({ necessary: true, functional: true, analytics: true, ads: true });
}

export function rejectAll() {
  saveConsent({ necessary: true, functional: false, analytics: false, ads: false });
}

export function openPreferences() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("geolitio:open-cookie-preferences"));
}
